import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PlanDinner from "@/pages/PlanDinner";
import GroupPage from "@/pages/GroupPage";
import Preferences from "@/pages/Preferences";
import Restaurants from "@/pages/Restaurants";
import RestaurantDetail from "@/pages/RestaurantDetail";
import History from "@/pages/History";
import DinnerDetail from "@/pages/DinnerDetail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Rsvp from "@/pages/Rsvp";
import Nav from "@/components/Nav";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-muted-foreground">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return (
    <>
      <Nav />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/rsvp/:token" element={<Rsvp />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/plan" element={<Protected><PlanDinner /></Protected>} />
          <Route path="/group" element={<Protected><GroupPage /></Protected>} />
          <Route path="/preferences" element={<Protected><Preferences /></Protected>} />
          <Route path="/restaurants" element={<Protected><Restaurants /></Protected>} />
          <Route path="/restaurants/:id" element={<Protected><RestaurantDetail /></Protected>} />
          <Route path="/history" element={<Protected><History /></Protected>} />
          <Route path="/dinners/:id" element={<Protected><DinnerDetail /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
